import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { photos } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
export function Community() {
  return <section id="community" aria-labelledby="community-title" className="on-dark bg-coal py-20 text-white lg:py-28" data-id="element-99" data-mp="lz9ux19qy7w1">
      <Container className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-100" data-mp="qwt9616g2knz">
        <div className="lg:col-span-7" data-id="element-101" data-mp="vvctjx5e3oe8">
          <img src={photos.medal} alt="A Bates Taekwondo student celebrating with a medal" className="aspect-[4/3] w-full rounded object-cover lg:aspect-[3/2]" style={{
          objectPosition: '50% 30%'
        }} loading="lazy" data-id="element-102" data-mp="vy8vrxo9sz8h" />
        </div>

        <Reveal className="lg:col-span-5" data-id="element-103" data-mp="32p8bkpilgba6">
          <SectionTitle id="community-title" data-id="element-104" data-mp="36npailrv2fgi">Room to keep growing</SectionTitle>
          <p className="text-pretty mt-6 text-[1.05rem] leading-relaxed text-white/80" data-id="element-105" data-mp="3nt2g45n1ek3p">
            Some students discover they love to compete. Others train for skill, fitness and the friends they’ve made.
            Both belong at Bates.
          </p>

          <dl className="mt-8 divide-y divide-white/15 border-y border-white/15" data-id="element-106" data-mp="3e3sjqdl5uf9s">
            <div className="py-5" data-id="element-107" data-mp="395r6486i785p">
              <dt className="font-display text-xl font-semibold uppercase tracking-wide" data-id="element-108" data-mp="392leal6hps6a">General classes</dt>
              <dd className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-109" data-mp="5npo567boh1t">
                Beginner-friendly training focused on technique, fitness and personal progress.
              </dd>
            </div>
            <div className="py-5" data-id="element-110" data-mp="3rv60xkvlj11n">
              <dt className="font-display text-xl font-semibold uppercase tracking-wide" data-id="element-111" data-mp="3ru4dsi1b2o3k">Competition Team</dt>
              <dd className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-112" data-mp="2lgeuz2rm8q0r">
                An additional pathway for committed athletes, with coaching for tournament Taekwondo.
              </dd>
            </div>
          </dl>

          <ButtonLink href="/competition-team" variant="outlineLight" className="mt-8" icon={<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="yinip08sut7z" />} data-id="element-113" data-mp="18eh5dcg8g33h">
            About the Competition Team
          </ButtonLink>
        </Reveal>
      </Container>
    </section>;
}